export default __webpack_public_path__ + "static/media/reactStore.2f5a463a.png";